import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _ from "underscore";
import moment from "moment";
import { Link } from "react-router-dom";
import queryString from "query-string";
import {
  PlaysByStreamType,
  PlaysByEventType,
  TopCity,
  TopCountry,
  TopBrowsers,
  TopRefferrer,
  TopDevices,
  TopOS,
  TopPlatform,
  MediaReport,
  MediaEvolution,
  SocialNetworks,
  VideoTitles,
  SearchEngines,
  VideoDownloads,
  AudioDownloads,
} from "./components";
import DateRangePicker from "react-daterange-picker";
import "react-daterange-picker/dist/css/react-calendar.css";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@material-ui/core/Button";
import IconButton from '@material-ui/core/IconButton';
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { makeStyles } from "@material-ui/core/styles";
import CalendarMonthTwoToneIcon from "@mui/icons-material/CalendarMonthTwoTone";
import RotateLeftIcon from '@material-ui/icons/RotateLeft';

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  buttonCalendar: {
    fontSize: "12px",
  },
}));

function hasInvalidEventID(props) {
  const { event } = props;
  if (queryString.parse(window.location.search).eventID) {
    return event.hasFetched && !event.hasResults;
  }
  return true;
}
function hasValidEventID(props) {
  const { event } = props;
  if (queryString.parse(window.location.search).eventID) {
    return event.hasFetched && event.hasResults;
  } else {
    return false;
  }
}

const widgets = [
  [PlaysByEventType, TopCity, TopCountry, TopBrowsers, SearchEngines],
  [
    PlaysByStreamType,
    MediaReport,
    MediaEvolution,
    TopRefferrer,
    SocialNetworks,
  ],
  [VideoDownloads, AudioDownloads, TopOS, TopDevices, TopPlatform],
];

const filterOptions = (props) => {
  const { client, event } = props;
  const dateChanged = (date) => {
    setEndDate(date.end);
    setStartDate(date.start);
    setCalendarOpen(false);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [calendarOpen, setCalendarOpen] = useState(Boolean(anchorEl));

  const handleOpenDatePickerClick = (event) => {
    if (!calendarOpen) {
      setAnchorEl(event.currentTarget);
      setCalendarOpen(true);
    }
  };

  const handleDatePickerClose = () => {
    if (calendarOpen) {
      setAnchorEl(null);
    }
  };
  //var calendarOpen = Boolean(anchorEl);
  const popid = calendarOpen ? "date-popover" : undefined;
};

const AnalyticsView = (props) => {
  const classes = useStyles();
  const { client, event } = props;
  // analyticsconst eventData = !hasInvalidEventID(props) ? event.data : null;
  const [isLoading, setIsLoading] = useState(true);
  const [eventData, setEventData] = useState(null);
  // Default to the current calendar month -- resolvePeriodParam() snaps this to
  // Matomo period=month, which is cron-archived and renders for high-volume
  // sites. A rolling 30-day window resolves to period=range, which returns
  // empty for the largest client (TVW). See analytics components.js.
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );
  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [eventMinDate, setEventMinDate] = useState();

  useEffect(() => {
    if (queryString.parse(window.location.search).eventID) {
      if (hasValidEventID(props)) {
        setStartDate(moment(event.data.startDateTime).format("YYYY-MM-DD"));
        setEventMinDate(moment(event.data.startDateTime).format("YYYY-MM-DD"));
        setEventData(event.data);
      }
    }
  }, [hasValidEventID(props)]);

  const dateChanged = (date) => {
    setEndDate(date.end);
    setStartDate(date.start);
    setCalendarOpen(false);
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const [calendarOpen, setCalendarOpen] = useState(Boolean(anchorEl));

  const handleOpenDatePickerClick = (event) => {
    if (!calendarOpen) {
      setAnchorEl(event.currentTarget);
      setCalendarOpen(true);
    }
  };

  const handleDatePickerClose = () => {
    if (calendarOpen) {
      setAnchorEl(null);
      setCalendarOpen(false);
    }
  };
  //var calendarOpen = Boolean(anchorEl);
  const popid = calendarOpen ? "date-popover" : undefined;

  const handleDateFilterRange = (date) => {
    switch (date) {
      case "today":
        setStartDate(moment().format("YYYY-MM-DD"));
        setEndDate(moment().format("YYYY-MM-DD"));
        handleDatePickerClose();
        break;
      case "thisweek":
        setStartDate(moment().startOf("week").format("YYYY-MM-DD"));
        setEndDate(moment().endOf("week").format("YYYY-MM-DD"));
        handleDatePickerClose();
        break;
      case "thismonth":
        setStartDate(moment().startOf("month").format("YYYY-MM-DD"));
        setEndDate(moment().endOf("month").format("YYYY-MM-DD"));
        handleDatePickerClose();
        break;
      case "thisquarter":
        setStartDate(moment().startOf("quarter").format("YYYY-MM-DD"));
        setEndDate(moment().endOf("quarter").format("YYYY-MM-DD"));
        handleDatePickerClose();
        break;
      case "yesterday":
        setStartDate(moment().subtract(1, "days").format("YYYY-MM-DD"));
        setEndDate(moment().subtract(1, "days").format("YYYY-MM-DD"));
        handleDatePickerClose();
        break;
      case "lastweek":
        setStartDate(
          moment().subtract(1, "weeks").startOf("week").format("YYYY-MM-DD")
        );
        setEndDate(
          moment().subtract(1, "weeks").endOf("week").format("YYYY-MM-DD")
        );
        handleDatePickerClose();
        break;
      case "lastmonth":
        setStartDate(
          moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD")
        );
        setEndDate(
          moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD")
        );
        handleDatePickerClose();
        break;
      case "lastquarter":
        setStartDate(
          moment()
            .subtract(1, "quarter")
            .startOf("quarter")
            .format("YYYY-MM-DD")
        );
        setEndDate(
          moment().subtract(1, "quarter").endOf("quarter").format("YYYY-MM-DD")
        );
        handleDatePickerClose();
        break;

      default:
        setStartDate(moment().startOf("month").format("YYYY-MM-DD"))
        setEndDate(moment().endOf("month").format("YYYY-MM-DD"))
        break;
    }
  };

  /* const dateRanges = {
    "Last 7 days": moment.range(
      today.clone().subtract(7, "days"),
      today.clone()
    ),
    "This Year": moment.range(today.clone().startOf("year"), today.clone()),
  }; */

  return (
    <>
      {EventHeader(props)}

      <div className="analytics-filterBar">
        <div className="analytics-calendar">
          <Button
            className={classes.buttonCalendar}
            variant="outlined"
            size="large"
            aria-describedby={popid}
            onClick={handleOpenDatePickerClick}
            endIcon={<CalendarMonthTwoToneIcon />}
            style={{ fontSize: "14px" }}
          >
            Date Filter
          </Button>
          <IconButton color="primary" aria-label="reset" component="span" onClick={(e) => handleDateFilterRange(null)}>
          <RotateLeftIcon />
          </IconButton>
        
          <Popover
            id={popid}
            open={calendarOpen}
            anchorEl={anchorEl}
            onClose={handleDatePickerClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <DateRangePicker
              minimumDate={moment().add(-2, "years").toDate()}
              firstOfWeek={1}
              numberOfCalendars={3}
              selectionType="range"
              singleDateRange={true}
              maximumDate={moment().add(2, "years").toDate()}
              onSelect={(e) => dateChanged(e)}
              // stateDefinitions={stateDefinitions}
              //dateStates={dateRanges}
              //defaultState="available"
              value={moment.range(startDate, endDate)}
              // showLegend={true}
            />
            <div className={classes.root}>
              <ButtonGroup size="large" color="primary">
                <Button
                  className={classes.buttonCalendar}
                  onClick={(e) => handleDateFilterRange("today")}
                >
                  Today
                </Button>
                <Button
                  className={classes.buttonCalendar}
                  onClick={(e) => handleDateFilterRange("thisweek")}
                >
                  This Week
                </Button>
                <Button
                  className={classes.buttonCalendar}
                  onClick={(e) => handleDateFilterRange("thismonth")}
                >
                  This Month
                </Button>
                <Button
                  className={classes.buttonCalendar}
                  onClick={(e) => handleDateFilterRange("thisquarter")}
                >
                  This Quarter
                </Button>
              </ButtonGroup>
              <ButtonGroup size="large" color="primary">
                <Button
                  className={classes.buttonCalendar}
                  onClick={(e) => handleDateFilterRange("yesterday")}
                >
                  Yesterday
                </Button>
                <Button
                  className={classes.buttonCalendar}
                  onClick={(e) => handleDateFilterRange("lastweek")}
                >
                  Last Week
                </Button>
                <Button
                  className={classes.buttonCalendar}
                  onClick={(e) => handleDateFilterRange("lastmonth")}
                >
                  Last Month
                </Button>
                <Button
                  className={classes.buttonCalendar}
                  onClick={(e) => handleDateFilterRange("lastquarter")}
                >
                  Last Quarter
                </Button>
              </ButtonGroup>

              <Button
                className={classes.buttonCalendar}
                color="primary"
                aria-label="Close Filter"
                onClick={handleDatePickerClose}
              >
                CLOSE
              </Button>
            </div>
          </Popover>
        </div>
        <h5 className="analytics-dateText">
          Date Range:{" "}
          {moment(startDate).format("YYYY-MM-DD") +
            " through " +
            moment(endDate).format("YYYY-MM-DD")}
        </h5>
      </div>

      <div className="report-area">
        {widgets.map((column, i) => (
          <div className="analytics-column" key={i}>
            {column.map((Widget, i) => (
              <Widget
                key={i}
                event={eventData}
                siteID={client.analyticSiteID}
                clientID={client.clientID}
                date={{ startDate, endDate }}
              />
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

var TIME_HUMAN_PARTIAL = "h:mm A";
var DATE_HUMAN = "MMM. DD, YYYY";
const EventHeader = (props) => {
  const { event } = props;
  const hasEvent = !hasInvalidEventID(props);
  if (hasEvent) {
    return (
      <div>
        <h2
          style={{
            display: "inline-block",
            margin: "0 1em 2rem 0",
          }}
        >
          <Link to={"/events/?eventID=" + event.data.eventID}>
            {event.data.title}
          </Link>
        </h2>

        <span>
          {moment(event.data.startDateTime).format(DATE_HUMAN)}
          {", " + moment(event.data.startDateTime).format(TIME_HUMAN_PARTIAL)}
        </span>
      </div>
    );
  } else if (queryString.parse(window.location.search).eventID) {
    return (
      <div className="alert alert-warning alert-dismissible" role="alert">
        <button
          type="button"
          className="close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <strong>Warning!</strong> The event passed to this page is not a valid
        event ID. Analytic data will reflect the defaults
      </div>
    );
  } else {
    return null;
  }
};

export default AnalyticsView;
